// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/spend_management/memberships/bank_details/firstparty/v3/create_bank_details.proto

/* oxlint-disable */
import { ApiMembershipBankDetails } from "./bank_details";

/** Input shape matching { "membership_bank_details": { "iban": "..." } } request body. */
export interface ApiCreateBankDetailsInput {
  /** The IBAN to associate with the membership. */
  readonly iban: string;
}

/** Request message for CreateBankDetails. */
export interface ApiCreateBankDetailsRequest {
  /** The ID of the membership (path parameter). */
  readonly id: string;
  /** The bank details input. */
  readonly membershipBankDetails: ApiCreateBankDetailsInput | null;
}

/** Response message for CreateBankDetails. */
export interface ApiCreateBankDetailsResponse {
  /** The created bank details. */
  readonly membershipBankDetails: ApiMembershipBankDetails | null;
}

export const ApiCreateBankDetailsInput: MessageFns<ApiCreateBankDetailsInput> = {
  fromJSON(object: any): ApiCreateBankDetailsInput {
    return { iban: isSet(object.iban) ? globalThis.String(object.iban) : "" };
  },

  toJSON(message: ApiCreateBankDetailsInput): unknown {
    const obj: any = {};
    if (message.iban !== undefined && message.iban !== null) {
      obj.iban = message.iban;
    }
    return obj;
  },
};

export const ApiCreateBankDetailsRequest: MessageFns<ApiCreateBankDetailsRequest> = {
  fromJSON(object: any): ApiCreateBankDetailsRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      membershipBankDetails: isSet(object.membershipBankDetails)
        ? ApiCreateBankDetailsInput.fromJSON(object.membershipBankDetails)
        : null,
    };
  },

  toJSON(message: ApiCreateBankDetailsRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.membershipBankDetails !== undefined && message.membershipBankDetails !== null) {
      obj.membershipBankDetails = ApiCreateBankDetailsInput.toJSON(message.membershipBankDetails);
    }
    return obj;
  },
};

export const ApiCreateBankDetailsResponse: MessageFns<ApiCreateBankDetailsResponse> = {
  fromJSON(object: any): ApiCreateBankDetailsResponse {
    return {
      membershipBankDetails: isSet(object.membershipBankDetails)
        ? ApiMembershipBankDetails.fromJSON(object.membershipBankDetails)
        : null,
    };
  },

  toJSON(message: ApiCreateBankDetailsResponse): unknown {
    const obj: any = {};
    if (message.membershipBankDetails !== undefined && message.membershipBankDetails !== null) {
      obj.membershipBankDetails = ApiMembershipBankDetails.toJSON(message.membershipBankDetails);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
